import React, { useState } from "react"

import Button from "@/components/core/Button/Button"

const SuccessMessage = ({
  confirmationTitle,
  confirmationDescription,
  closeModal,
  promoCode,
  copyCtaText,
  copiedCtaText,
  isGiftCodeEnable,
}) => {
  const [copySuccess, setCopySuccess] = useState(copyCtaText)
  const copyToClipBoard = async copyMe => {
    try {
      await navigator.clipboard.writeText(copyMe)
      setCopySuccess(copiedCtaText)
    } catch (err) {
      setCopySuccess("Failed to copy!")
    }
  }
  return (
    <div className="news-letter-sign-up__success-modal">
      <p className="news-letter-sign-up__thanks">{confirmationTitle}</p>
      <span className="news-letter-sign-up__success">
        {confirmationDescription}
      </span>
      {isGiftCodeEnable && promoCode ? (
        <div className="copy-code-section">
          <div className="copy-code-number">{promoCode}</div>
          <div className="copy-code-button">
            <Button
              role="button"
              label={copySuccess}
              type="primary"
              onClick={() => copyToClipBoard(promoCode)}
            />
          </div>
        </div>
      ) : null}
      <Button
        className="success-modal-button"
        parentClass={"parent-wrap"}
        label="Continue Shopping"
        size="small"
        type="primary"
        flexible
        role={"button"}
        onClick={closeModal}
      />
    </div>
  )
}

export default SuccessMessage
